import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { WhiteBoardDialogProps } from '../src/whiteboards/WhiteBoardPublishDiscoveryDialog.tsx';

export const LazyWhiteBoardPublishDiscoveryDialog: LoadableType<WhiteBoardDialogProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-WhiteBoardPublishDiscoveryDialog" */ '../src/whiteboards/WhiteBoardPublishDiscoveryDialog.tsx'
				)
			).WhiteBoardPublishDiscoveryDialog,
	});
